<template>
  <div>
    <h1 class="display-3">Odznaczenie dla Generała A. Krzyżanowskiego "Wilka"</h1><br/>

    <b-row>
      <b-col md="6" order-md="1" order="2">
        <b-embed type="iframe"
          aspect="16by9"
          src="https://www.youtube.com/embed/0bA96iGL1Jw"
          allowfullscreen
        ></b-embed>
      </b-col>
      <b-col md="6" order-md="2" order="1">
        <p class="lead">
          Żołnierze Armii Krajowej Okręgu Wileńskiego i Nowogródzkiego na spotkaniu u Prezydenta Rzeczpospolitej dla
          wręczenia po śmierci odznaczenia dla gen. A. Krzyżanowskiego "Wilka"<br/>
          <i>Warszawa 17.09.2012</i>
        </p>
      </b-col>
    </b-row>

  </div>
</template>

<script>
export default {
  name: 'odzn_gen_krzyzanowski',
  metaInfo:{
    title: 'Odznaczenie dla Generała A. Krzyżanowskiego "Wilka"',
    meta:[
      {name: 'description', content: 'Żołnierze Armii Krajowej Okręgu Wileńskiego i Nowogródzkiego na spotkaniu u Prezydenta Rzeczpospolitej dla wręczenia po śmierci odznaczenia dla gen. A. Krzyżanowskiego "Wilka" Warszawa 17.09.2012' },
      {name: 'og:url', content: 'http://akwilno.pl/odzn_gen_krzyzanowski' },
      {name: 'og:title', content: 'Odznaczenie dla Generała A. Krzyżanowskiego "Wilka"' },
      {name: 'og:image', content: '/aktualnosci/odzn_gen_krzyzanowski.jpg' },
      {name: 'og:description', content: 'Żołnierze Armii Krajowej Okręgu Wileńskiego i Nowogródzkiego na spotkaniu u Prezydenta Rzeczpospolitej dla wręczenia po śmierci odznaczenia dla gen. A. Krzyżanowskiego "Wilka" Warszawa 17.09.2012' },
      {name: 'twitter:url', content: 'http://akwilno.pl/odzn_gen_krzyzanowski' },
      {name: 'twitter:title', content: 'Odznaczenie dla Generała A. Krzyżanowskiego "Wilka"' },
      {name: 'witter:image', content: '/aktualnosci/odzn_gen_krzyzanowski.jpg' },
      {name: 'twitter:description', content: 'Żołnierze Armii Krajowej Okręgu Wileńskiego i Nowogródzkiego na spotkaniu u Prezydenta Rzeczpospolitej dla wręczenia po śmierci odznaczenia dla gen. A. Krzyżanowskiego "Wilka" Warszawa 17.09.2012' }
    ]
  }
}
</script>



// WEBPACK FOOTER //
// src/components/aktualnosci/odzn_gen_krzyzanowski.vue